import { useState, useCallback } from "react";

/**
 * Custom hook for managing filter states
 * @param {Object} initialFilters - Initial filter values
 * @returns {Object} - Returns filter state and handlers
 */
export function useFilters(initialFilters = {}) {
  const [filters, setFilters] = useState(initialFilters);

  const updateFilter = useCallback((field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  }, []);

  const updateFilters = useCallback((newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  }, []);

  const clearFilters = useCallback(() => {
    const clearedFilters = { ...filters };
    Object.keys(clearedFilters).forEach(key => {
      if (key.toLowerCase().includes('date')) {
        clearedFilters[key] = null;
      } else {
        clearedFilters[key] = "";
      }
    });
    setFilters(clearedFilters);
  }, [filters]);

  const hasActiveFilters = () => {
    return Object.values(filters).some(value => {
      if (value === null || value === undefined || value === "") return false;
      return true;
    });
  };

  return {
    filters,
    updateFilter,
    updateFilters,
    clearFilters,
    hasActiveFilters: hasActiveFilters()
  };
}
